<template>
  <div>
    <div v-if="$store.state.step === 2" class="text-center">
      <h4>Edit Details</h4>
      <div style="80%">
        <b-form-textarea
          id="introBlurb"
          name="introBlurb"
          placeholder="Intro welcome blurb"
          v-model="introBlurb"
          rows="3"
        ></b-form-textarea>
      </div>
      <div style="80%">
        <b-form-textarea
          id="name"
          name="name"
          placeholder="name"
          v-model="name"
          rows="3"
        ></b-form-textarea>
      </div>
      <div style="80%">
        <b-form-textarea
          id="title"
          name="title"
          placeholder="title"
          v-model="title"
          rows="3"
        ></b-form-textarea>
      </div>
      <br />
      <br />
    </div>
  </div>
</template>
<script>
export default {
  name: "StepTwo",
  mounted() {},
  data: function() {
    return {
      no_headshot: "https://i.imgur.com/Gcvs580m.png",
    };
  },
  computed: {
    introBlurb: {
      get() {
        return this.$store.state.customization.introBlurb;
      },
      set(value) {
        this.$store.commit("changeIntroBlurb", value);
      },
    },
    name: {
      get() {
        return this.$store.state.customization.name;
      },
      set(value) {
        this.$store.commit("changeName", value);
      },
    },
    title: {
      get() {
        return this.$store.state.customization.title;
      },
      set(value) {
        this.$store.commit("changeTitle", value);
      },
    },
  },
  methods: {
    next() {
      this.$store.commit("changeStep", 3);
    },
    prev() {
      this.$store.commit("changeStep", 1);
    },
    setStep(newStep) {
      this.$store.commit("changeStep", newStep);
    },
  },
};
</script>
